import {HistoryMessage} from "../../../../types/history";
import {AlmeUIResponseArray} from "../../../../types/response";


//#region Action Interfaces

export interface SendHistoryRequestAction
{
    type: "SEND_HISTORY_REQUEST";
    payload: {
        messages: HistoryMessage[] | AlmeUIResponseArray;
        stateLocation: string;
    };
}

//#endregion



//#region Action Constructors

export function receivedHistoryResponse(messages: HistoryMessage[] | AlmeUIResponseArray, stateLocation: string): SendHistoryRequestAction
{
    return {
        type : "SEND_HISTORY_REQUEST",
        payload : {
            messages,
            stateLocation,
        },
    };
}

//#endregion



// WEBPACK FOOTER //
// ./node_modules/@alme/ui-web/modules/initialization-gethistory/src/actions/actions.ts